import React, { createContext } from "react";
import { EmptyProject } from "../models/Project.ts";

export const ProjectContext = createContext<ProjectContextType | null>(null);
export const ProjectDispatchContext = createContext<
  React.ActionDispatch<[action: ProjectAction]>
>(() => void 0);

export type ProjectAction =
  | { type: "set"; project: ProjectContextType }
  | { type: "update"; project: Partial<ProjectContextType> }
  | { type: "delete" };

export function projectReducer(
  prevState: ProjectContextType,
  action: ProjectAction,
): ProjectContextType {
  switch (action.type) {
    case "set": {
      return action.project;
    }
    case "update": {
      return { ...prevState, ...action.project };
    }
    default:
    case "delete": {
      return EmptyProject;
    }
  }
}
